<key-search
    class="selection"
    [(searchValue)]="searchValue"
    [placeholder]="'SHARED.SELECTION.SEARCH' | translate: { type: typeName }"
    [autoFocus]="true"
    (submitSearch)="changeSearch($event)"
    (clear)="changeSearch(null)"
>
</key-search>

@if (errorMessage) {
    <kui-alert-panel [message]="errorMessage" [actionText]="'DIALOG.RETRY' | translate" (onAction)="changeSearch(searchValue)"></kui-alert-panel>
}

@if (entities && entities.length === 0 && !errorMessage) {
    <kui-alert type="info" class="key-alert-wrapper no-padding">
        <kui-icon name="lightbulb" size="sm"></kui-icon>
        <span>{{ "SHARED.SELECTION.NO_ITEMS" | translate: { type: typeName } }}</span>
    </kui-alert>
}

@if (!loaded) {
    <div class="loading-overlay d-flex flex-stretch justify-content-center align-items-center">
        <kui-loader> </kui-loader>
    </div>
}

@if (!errorMessage) {
    <div class="overflow-auto px-3" #assetList>
        @for (entity of filterEntities(entities); track entity; let idx = $index) {
            <div
                (click)="selectEntity(entity)"
                class="d-flex list-item pb-2 pt-2"
                [class.highlight]="highlightIndex === idx"
                [class.muted]="checkDisabled(entity)"
                [class.table-hover-state]="!checkDisabled(entity)"
            >
                @if (entity.logoPath !== undefined) {
                    <div class="logo">
                        <div class="mr-4">
                            @if (entity.logoPath) {
                                <img [src]="entity.logoPath" (error)="entity.logoPath = null" />
                            } @else {}
                        </div>
                    </div>
                }
                @if (entity.avatarPath !== undefined) {
                    <div class="avatar">
                        <div class="mr-4">
                            @if (entity.avatarPath) {
                                <img class="border-round" [src]="entity.avatarPath" (error)="entity.avatarPath = null" />
                            } @else {
                                <div class="avatar-image-text border-round d-inline-block bg-primary color-text-inverse text-center">
                                    <strong>{{ entity.name[0] }}</strong>
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (entity.iconName) {
                    <div>
                        <kui-icon [name]="entity.iconName" class="ml-1 mr-3" [ngStyle]="{ color: entity.color }"></kui-icon>
                    </div>
                }
                <div class="flex-1 d-flex justify-content-center flex-column">
                    <div>{{ entity.name }}</div>
                    @if (entity.description) {
                        <div class="muted-less">{{ entity.description }}</div>
                    }
                </div>
            </div>
        }
    </div>
    @if (total > limit) {
        <div class="pt-3 d-flex flex-row p-3">
            <div class="flex-1"></div>
            <kui-paginate #paginator [page]="page" [total]="total" [perPage]="limit" [collapse]="true" (pageChanged)="onPageChanged($event)"></kui-paginate>
        </div>
    }
}
